export default __webpack_public_path__ + "static/media/hendersons_logo.f8f79a57.svg";